module.exports = __webpack_public_path__ + "templates-59e97cd7/template-7-preview-d132bb2d8dc18513da52a98cbe052aa0.jpg";